module.exports = __webpack_public_path__ + "img/136.f8aaa31b.jpg";